import Alert from '@mui/material/Alert';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type ConfirmationModalParams = {
  isEdit?: boolean;
  statusMessage?: string | null;
};

export const ConfirmationModalContent = ({ isEdit, statusMessage }: ConfirmationModalParams) => {
  const { t } = useTranslation();

  const alertTypeExpectedText =
    statusMessage ??
    'Changing deal/package targeting will cause this deal to run without Engagement optimization while request volumes are reassessed.';

  return (
    <DialogContent dividers>
      <Alert severity="warning" sx={{ marginBottom: 2 }} data-test="rbo-alert">
        <strong>{t('CAUTION: ')}</strong>
        {`${t(alertTypeExpectedText)} `}
        <strong>{t('Steady state performance may take up to 48 hours.')}</strong>
      </Alert>
      <Typography
        variant="body1"
        data-test="explanation"
        sx={{
          mt: 1,
        }}
      >
        {isEdit ? t('Press save to update the deal and confirm updates.') : t('Press save to create the deal.')}
      </Typography>
    </DialogContent>
  );
};
